module.exports = __webpack_public_path__ + "img/TECNOLOGIA-SWIFT-BOOSTER-GREEN-3.9e05d689.jpg";